import TextMessagePolicy from "@/pages/textMessagePolicy";
import { createPublicSsrPage } from "../../src/vike/createPublicSsrPage";
import { PATHS } from "../../src/shared/publicPaths";

export default createPublicSsrPage({
  pathname: PATHS.textMessage,
  overrideKey: "textMessagePolicy",
  element: <TextMessagePolicy />,
});
